import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { AddressInfoDto, BaseBackResponse } from '@savgroup-front-common/types';

const HANDLING_MODE = ':handlingMode';
const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/addresses/${HANDLING_MODE}`;

interface UpdateFileAddressArgs {
  fileId: string;
  handlingMode: string;
  address: AddressInfoDto;
}

export const updateFileAddressRequest = (
  payload: UpdateFileAddressArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId).replace(
    HANDLING_MODE,
    payload.handlingMode,
  ),
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { addressInfo: payload.address },
  },
});

async function updateFileAddress(
  payload: UpdateFileAddressArgs,
): Promise<BaseBackResponse> {
  try {
    return await executeQuery<BaseBackResponse>(
      updateFileAddressRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default updateFileAddress;
